// src/components/Footer.jsx
import React from 'react';
import SvgLoader from "../utils/SVGLoader";

const Footer = (props) => {
  const content = props.content || {};

  const Logo = (props) => (
    <div className={`flex items-center space-x-2 ${props.className}`}>
      {/* Logo */}
      <SvgLoader url={content.logoSvgUrl} className="w-8 h-8 text-pf-bgDarker" />

      {/* Title */}
      <span className="font-semibold text-pf-bgDarker">{content.productName}</span>
    </div>
  )

  return (
    <footer className="bg-[#1F2D23] text-white pt-12 pb-6 px-6 md:px-16 min-h-[30vh] w-full flex flex-col items-center justify-between">
      <div className="wrapper flex flex-col md:flex-row justify-between items-start md:items-center gap-8">

        {/* Logo and Tagline */}
        <div className="w-full flex flex-col items-start gap-2">
          <div className="flex items-center justify-start gap-2 text-2xl font-bold">
            <Logo />
          </div>
          <p className="text-lg font-medium text-gray-400">
            {content.footer.title}
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-col items-start md:justify-end w-full md:flex-row gap-4 text-sm font-medium">
          {content.footer.links.map((link, index) => (
            <a key={index} href={link.item.url} className="no-underline text-gray-400 hover:text-gray-200">{link.item.label}</a>
          ))}
        </div>
      </div>

      {/* Bottom small text */}
      <div className="my-16 md:my-2 text-center text-xs text-gray-500">
        {content.footer.credits}
      </div>
    </footer>
  );
}

export default Footer;
